import axiosConfig from "./axiosConfig";

export interface HhDataOutputMetaData {
  date_of_analysis: string;
  combined_df_gaps: Array<{
    start: string;
    end: string;
    rows: number;
    method: string;
  }>;
  latest_full_year_num_rows: number;
  latest_full_year_num_rows_customer_data: number;
  typical_year_start: string;
  typical_year_end: string;
  typical_year_data_sum: number;
  input_file: string;
  site_mapping: Record<string, string>;
  input_data_start: string;
  input_data_end: string;
  fullyear_data_start: string;
  fullyear_data_end: string;
  largest_gap_days?: number;
}

export interface HhDataMetadataResponse {
  metadata: HhDataOutputMetaData;
}

const getHhDataMetadata = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataMetadataResponse> => {
  const { data } = await axiosConfig.get(`/hh_data/${fileGuid}/metadata`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getHhDataMetadata;
